<h2 mat-dialog-title class="text-center">
  {{ 'PROLONGERRESERVATION.TITLE' | translate }}
</h2>

<!-- <h2>{{book |json}}</h2> -->

<div mat-dialog-content>





  <div class="col-12 marge mt-4">
    <div class="row">
      <div class="col-sm-6 col-12">
        <div class="row row-no-gutters">
          <mat-form-field class="col-sm-6">
            <input matInput [matDatepicker]="picker1" [min]="_start" [max]="_start" disabled
              placeholder="{{ 'PROLONGERRESERVATION.START' | translate }}" [(value)]="_start">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <div class="col-sm-6">
            <div class="row">
              <mat-form-field class="col-sm-6">
                <mat-select disabled [(value)]="_hourS">
                  <mat-option value="0">00</mat-option>
                  <mat-option value="1">01</mat-option>
                  <mat-option value="2">02</mat-option>
                  <mat-option value="3">03</mat-option>
                  <mat-option value="4">04</mat-option>
                  <mat-option value="5">05</mat-option>
                  <mat-option value="6">06</mat-option>
                  <mat-option value="7">07</mat-option>
                  <mat-option value="8">08</mat-option>
                  <mat-option value="9">09</mat-option>
                  <mat-option value="10">10</mat-option>
                  <mat-option value="11">11</mat-option>
                  <mat-option value="12">12</mat-option>
                  <mat-option value="13">13</mat-option>
                  <mat-option value="14">14</mat-option>
                  <mat-option value="15">15</mat-option>
                  <mat-option value="16">16</mat-option>
                  <mat-option value="17">17</mat-option>
                  <mat-option value="18">18</mat-option>
                  <mat-option value="19">19</mat-option>
                  <mat-option value="20">20</mat-option>
                  <mat-option value="21">21</mat-option>
                  <mat-option value="22">22</mat-option>
                  <mat-option value="23">23</mat-option>

                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-sm-6">
                <mat-select disabled [(value)]="_minS">
                  <mat-option value="0"> 00</mat-option>
                  <mat-option value="30"> 30</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </div>
        </div>
      </div>

      <div class="col-1 mid d-none d-sm-block">
        <mat-icon aria-hidden="false" aria-label="Example home icon">trending_flat</mat-icon>
      </div>

      <!-- fin  -->
      <div class="col-lg-5 col-12 end">
        <label>
          <div class="row row-no-gutters">
            <mat-form-field class="col-sm-6">
              <input [disabled]="_extend" matInput [matDatepicker]="picker" [min]="data.enddate"
                placeholder="{{ 'PROLONGERRESERVATION.END' | translate }}" [(value)]="_end"
                (dateInput)="updateDate('input', $event)" (dateChange)="updateDate('change', $event)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <div class="col-sm-6">
              <div class="row">
                <mat-form-field class="col-sm-6">
                  <mat-select [disabled]="_extend" [(value)]="_hour" (selectionChange)="updateHour('change', $event)">
                    <mat-option value="0">00</mat-option>
                    <mat-option value="1">01</mat-option>
                    <mat-option value="2">02</mat-option>
                    <mat-option value="3">03</mat-option>
                    <mat-option value="4">04</mat-option>
                    <mat-option value="5">05</mat-option>
                    <mat-option value="6">06</mat-option>
                    <mat-option value="7">07</mat-option>
                    <mat-option value="8">08</mat-option>
                    <mat-option value="9">09</mat-option>
                    <mat-option value="10">10</mat-option>
                    <mat-option value="11">11</mat-option>
                    <mat-option value="12">12</mat-option>
                    <mat-option value="13">13</mat-option>
                    <mat-option value="14">14</mat-option>
                    <mat-option value="15">15</mat-option>
                    <mat-option value="16">16</mat-option>
                    <mat-option value="17">17</mat-option>
                    <mat-option value="18">18</mat-option>
                    <mat-option value="19">19</mat-option>
                    <mat-option value="20">20</mat-option>
                    <mat-option value="21">21</mat-option>
                    <mat-option value="22">22</mat-option>
                    <mat-option value="23">23</mat-option>

                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-sm-6">
                  <mat-select [disabled]="_extend" [(value)]="_min" (selectionChange)="updateMin('change', $event)">
                    <mat-option value="0"> 00</mat-option>
                    <mat-option value="30"> 30</mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- <p>{{ f |json}}</p>
                    <p>{{ _hour |json}}</p>  -->

              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>




  <div *ngIf="_extend">


    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-md-3">
          <p class="text-center">{{ 'PROLONGERRESERVATION.NEWPRICE' | translate }} :</p>
        </div>
        <div class="col-md-3">
          <p class="text-center text-md-left">{{_extend.final_price }} €</p>
        </div>
      </div>
    </div>
  </div>




</div>


<div *ngIf="isMamSncf() === false" mat-dialog-actions class="row justify-content-center mt-3 mb-2 mb-md-0">
  <button [ngClass]="{'recharge-gradien': data.type === 0 || data.type === 7,  'autopartage-gradien': data.type === 1}"
    *ngIf="!_extend" mat-raised-button class="mr-2 btn"  color="primary"  (click)="sendConfirm()">{{
    'PROLONGERRESERVATION.BOUTONSELECT' | translate }}</button>
  <button [ngClass]="{'recharge-gradien': data.type === 0 || data.type === 7,  'autopartage-gradien': data.type === 1}"
    *ngIf="_extend" mat-raised-button class="mr-2 btn" color="primary" (click)="postExtend()">{{
    'PROLONGERRESERVATION.BOUTONCONFIRME' | translate }}</button>
  <button [ngClass]="{'recharge-gradien': data.type === 0 || data.type === 7,  'autopartage-gradien': data.type === 1}"
    mat-raised-button class="ml-2 btn"  color="primary" (click)="onNoClick()">{{
    'PROLONGERRESERVATION.BOUTONCANCEL' | translate }}</button>
</div>


<div *ngIf="isMamSncf() === true" mat-dialog-actions class="row justify-content-center mt-3 mb-2 mb-md-0">
  <button class="mamsncf_buton" 
    *ngIf="!_extend" mat-raised-button class="mr-2"  color="primary"  (click)="sendConfirm()">{{
    'PROLONGERRESERVATION.BOUTONSELECT' | translate }}</button>
  <button class="mamsncf_buton" 
    *ngIf="_extend" mat-raised-button class="mr-2" color="primary" (click)="postExtend()">{{
    'PROLONGERRESERVATION.BOUTONCONFIRME' | translate }}</button>
  <button class="mamsncf_buton" 
    mat-raised-button class="ml-2 "  color="primary" (click)="onNoClick()">{{
    'PROLONGERRESERVATION.BOUTONCANCEL' | translate }}</button>
</div>